<template>
    <div>
         <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'member_info_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員查詢 / 臨櫃付款未取紀錄({{this.$route.params.membername}})</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <!-- Second Data Table Starts Here-->
            <b-card class="bg-default-card">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="p-4 box-shadow" header="Form Elements">
                            <div class="table-responsive">
                                <table id="mytable" class="table table-bordred table-striped">
                                    <thead>
                                        <tr>
                                            <th>訂單時間</th>
                                            <th>訂單編號</th>
                                            <th>金額</th>
                                            <th>訂單狀態</th>
                                            <th>付款狀態</th>
                                            <th>系統自動變更為黑名單時間</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="v in Datalist" :key="v.CreatedAt">
                                            <td>{{v.CreatedAt | formatDate}}</td>
                                            <td>{{v.Code}}</td>
                                            <td>{{v.Total}}</td>
                                            <td>{{v.ProcessType}}</td>
                                            <td>{{v.Payed}}</td>
                                            <td v-if='v.StorepayBlackTime === null'></td>
                                            <td v-if='v.StorepayBlackTime !== null'>{{v.StorepayBlackTime | formatDate}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row" style="padding: 0 1rem">
                                <b-pagination size="md" :total-rows="model.totalrows" v-model="model.currentPage" :per-page="model.rows" @change="getmemberOrderlist"></b-pagination>
                                <label style="margin:8px">{{model.startRowNum}}到{{model.endRowNum}}，總共 {{model.totalrows}}筆</label>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  name: 'add_user',
  data () {
    return {
      formstate: {},
      Datalist: [],
      model: {
        currentPage: 0,
        perPage: 0,
        rows: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0
      },
      old_file: ''
    }
  },
  components: {
  },
  methods: {
    getmemberOrderlist: function (currentPage) {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/storepaynopay/v1', {
        memberid: this.$route.params.memberid,
        toPage: parseInt(currentPage),
        perPage: parseInt(this.model.rows)
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.Datalist = response.data.data
            this.model.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.model.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.model.rows * (this.model.currentPage - 1) + 1
            this.model.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.model.rows > response.data.totalRows) ? response.data.totalRows : (this.model.currentPage * this.model.rows) >= response.data.totalRows ? response.data.totalRows : this.model.currentPage * this.model.rows
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$router.push('/login')
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    }
  },
  mounted: function () {

  },
  destroyed: function () {

  },
  beforeMount: function () {
    this.getmemberOrderlist(1)
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  }
}
</script>
<style scoped>
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/StorepayHistory.vue